import(/* webpackMode: "eager" */ "C:\\Users\\YosefMajadley\\source\\repos\\Codit_ECommerce.CLIENT\\web\\src\\app\\[lng]\\error.tsx");
